import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const BetaBanner = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  const checkShow = () => {
    const dismissed = sessionStorage.getItem('amoraBetaDismissed');
    if (!dismissed) {
      setShowModal(true);
    }
  };

  useEffect(() => {
    checkShow();
    const interval = setInterval(() => {
      if (window.shouldResetBetaBanner) {
        window.shouldResetBetaBanner = false;
        checkShow();
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    sessionStorage.setItem('amoraBetaDismissed', 'true');
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="bg-white text-black border-4 border-black w-full max-w-lg p-8 uppercase font-bold tracking-wide">
        <h2 className="text-xl mb-4 border-b-2 border-black pb-2">⚠️ {t('beta.title')}</h2>
        <p className="text-base mb-4">{t('beta.description')}</p>
        <p className="text-base mb-6 text-red-700">{t('beta.mobile')}</p>
        <div className="flex justify-between items-center">
          <a href="/contact" className="underline hover:bg-black hover:text-white px-2 py-1 border border-black">
            💬 {t('beta.feedback')}
          </a>
          <button
            onClick={handleClose}
            className="bg-black text-white px-4 py-2 border-2 border-black hover:bg-white hover:text-black transition"
          >
            {t('beta.dismiss')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BetaBanner;
